import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IDefaultDatePicker } from 'components/uiKit/DatePicker'
import DatePicker from 'components/uiKit/DatePicker'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldDatePicker: React.FC<IControlProps<IDefaultDatePicker>> = ({
  name,
  onChange,
  ...props
}) => {
  const handleOnChange = useCallback(
    (value?: number | null) => onChange({ name, value }),
    [name, onChange],
  )

  return <DatePicker {...props} name={name} onChange={handleOnChange} />
}

export default FieldDatePicker
